<div class="footer" [style.visibility]="visibility">
  <div class="mobile reading-mode" *ngIf="!_isCommentaryEditorMode">
    <!-- 나의책 보기 버튼 (그룹책 보기일때 노출) -->
    <button
      *ngIf="isGroupReading"
      class="mode-button"
      [class.disabled]="!_isOwnedByUser"
      (click)="_changeToMyBookViewer()"
    >
      <sui-icon name="뷰어 그룹 변경"></sui-icon>나의책보기
    </button>

    <!-- 그룹책 보기 버튼 (나의책 보기일때 노출) -->
    <button
      *ngIf="!isGroupReading"
      class="mode-button"
      [class.disabled]="!_isOwnedByUser"
      [cdkMenuTriggerFor]="readingModeMenu"
    >
      <sui-icon name="뷰어 그룹 변경"></sui-icon>그룹책보기
    </button>

    <!-- 내 기록 버튼 (그룹책 보기와 나의책 보기일때 노출) -->
    <ng-container *ngIf="_groupMemberCount === 0">
      <span>혼자읽는 중</span>
      <div class="my-record-button-wrapper">
        <button
          *ngIf="!isGroupReading"
          class="my-record-button"
          (click)="_onMenuItemClick(MenuItem.MyRecord)"
        >
          내 기록
        </button>
      </div>
    </ng-container>

    <!-- 그룹원 수 버튼 (그룹책 보기일때 노출) -->
    <ng-container *ngIf="_groupMemberCount > 0">
      <button
        class="member-count-button"
        [class.disabled]="!_isOwnedByUser"
        (click)="_onMenuItemClick(MenuItem.GroupMembers)"
      >
        {{ _groupMemberCount }}
      </button>
      <p class="member-count-label-tablet">
        명이 '<span class="group-name">{{ _currentGroupName }}</span
        >' 그룹책 함께읽는 중
      </p>
      <p class="member-count-label-phone">명이 그룹책 함께읽는 중</p>
      <div class="expand"></div>
      <button
        class="group-memo-button"
        *ngIf="!_isUnderline"
        (click)="_onMenuItemClick(MenuItem.GroupMemos)"
      >
        전체 댓글
      </button>
    </ng-container>
  </div>

  <!-- 페이지 슬라이더 및 현재 페이지 위치 -->
  <div class="pdf-control">
    <viewer-pdf-page-slider
      class="slider"
      *ngIf="_bookType === BookType.PDF"
    ></viewer-pdf-page-slider>
    <viewer-buk-page-slider
      class="slider"
      *ngIf="_bookType === BookType.Buk"
    ></viewer-buk-page-slider>
    <viewer-document-page-slider
      class="slider"
      *ngIf="_bookType === BookType.Document"
    ></viewer-document-page-slider>
  </div>

  <!-- 모바일용 메뉴 버튼 -->
  <div class="mobile menus">
    <!-- 책판 버튼 -->
    <button
      class="icon-text-button"
      (click)="_onMenuItemClick(MenuItem.BookHome)"
    >
      <div class="icon">
        <sui-icon name="책 정보" type="solid"></sui-icon>
      </div>
      책판
    </button>

    <!-- 목차 버튼 -->
    <button class="icon-text-button" (click)="_onMenuItemClick(MenuItem.TOC)">
      <div class="icon">
        <sui-icon name="앱_도서 리스트" type="solid"></sui-icon>
      </div>
      목차
    </button>

    <!-- 페이지 목록 버튼 (PDF 뷰어에서만 노출) -->
    <button
      *ngIf="_bookType === BookType.PDF"
      class="icon-text-button"
      (click)="_onMenuItemClick(MenuItem.Thumbnail)"
    >
      <div class="icon">
        <sui-icon name="페이지 모아보기"></sui-icon>
      </div>
      페이지 목록
    </button>

    <!-- 뷰어 설정 버튼 -->
    <button
      class="icon-text-button"
      (click)="_onMenuItemClick(MenuItem.Settings)"
    >
      <div class="icon">
        <sui-icon name="환경설정"></sui-icon>
      </div>
      뷰어 설정
    </button>

    <!-- 도움말 버튼 -->
    <button class="icon-text-button" (click)="_onMenuItemClick(MenuItem.Help)">
      <div class="icon">
        <sui-icon name="도움말" type="solid"></sui-icon>
      </div>
      도움말
    </button>
  </div>
</div>
<div class="inset-spacer"></div>

<ng-template #readingModeMenu>
  <ng-container *ngIf="_groups.length > 0">
    <sui-menu size="small" cdkMenu>
      <button
        sui-menu-item
        cdkMenuItem
        *ngFor="let group of _groups"
        class="group-item"
        (click)="_onClickReadingGroup(group)"
      >
        <span>{{ group.name }}</span>
        <sui-icon
          *ngIf="group.is_liked"
          name="즐겨찾기"
          type="solid"
        ></sui-icon>
      </button>
    </sui-menu>
  </ng-container>
  <div class="no-group-message" *ngIf="_groups.length === 0">
    <p>현재 읽고 있는 그룹책이 없습니다</p>
    <span class="link" (click)="_onMenuItemClick(MenuItem.ReadingMode)"
      >그룹책 둘러보기</span
    >
  </div>
</ng-template>
